module.exports = __webpack_public_path__ + "img/fowi_btn_02.d5e96b15.png";